module.exports = __webpack_public_path__ + "f0621ded36a1582d37db4cf23ed746dd.MP3";